<section>
    <!-- Header -->
    <div>
      <p class="text-[10px] leading-4 font-bold uppercase text-[#4A9EDB] mb-3.5">
        {{ 'talentSearchV2.pipeline.kicker' | translate }}
      </p>
      <h2 class="text-[32px] md:text-[44px] lg:text-[52px] font-black text-[#061430] leading-tight"
          [innerHTML]="'talentSearchV2.pipeline.title' | translate | accent">
      </h2>
    </div>

    <!-- Pipeline illustration -->
    <div class="mt-12">
      <app-responsive-img
        name="pipeline"
        [alt]="'talentSearchV2.pipeline.imageAlt' | translate"
        imgClass="w-full h-auto rounded-2xl select-none pointer-events-none"
        sizes="100vw"
      />
    </div>

    <!-- CTA -->
    <div class="mt-12 text-center">
      <button
        type="button"
        (click)="openBookDemo()"
        class="inline-flex items-center gap-2 bg-primary shadow-[0px_4px_16px_0px_#353CD84D] text-white text-sm font-semibold rounded-full py-[15px] px-8 transition-opacity hover:opacity-90">
        {{ 'talentSearchV2.pipeline.cta' | translate }}
        <span class="inline-grid place-items-center rtl:flip"><app-icon name="tabler:arrow-narrow-right" [size]="18"/></span>
      </button>
    </div>
</section>
